import { Injectable } from '@angular/core';
import { FilesUtils } from 'src/app/utils/files.utils';
import { StringUtils } from 'src/app/utils/string.utils';
import { saveAs } from 'file-saver-es';

@Injectable({
  providedIn: 'root'
})
export class FilesDeviceService {

  public isDesktop(): boolean {
    return window.matchMedia('(min-width: 1025px)').matches;
  }

  public openOrDownloadPDF(base64: string, fileName: string): void {
    if (this.isDesktop()) {
      const blob = FilesUtils.base64ToBlob(base64, 'application/pdf');
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } else {
      const download = StringUtils.PrepareFileToDownload(base64);
      saveAs(download.file, `${fileName}.${download.extension}`);
    }
  }
}
